module.exports = __webpack_public_path__ + "assets/mp3/audio1/audio_1_2a.mp3";